import React from 'react';
import './ErrorMessage.css';

const ErrorMessage = ({
  message = 'Algo salió mal. Por favor, intenta de nuevo.',
  onRetry,
  type = 'error' // 'error', 'warning', 'info'
}) => {
  return (
    <div className={`error-message error-message--${type}`} role="alert" aria-live="polite">
      <div className="error-message__content">
        <div className="error-message__icon">
          {type === 'error' && (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <circle cx="12" cy="16" r="1" fill="currentColor"/>
            </svg>
          )}
          {type === 'warning' && (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9V13M12 17H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0377 2.66667 10.2679 4L3.33975 16C2.56995 17.3333 3.53223 19 5.07183 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
          {type === 'info' && (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 16V12M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          )}
        </div>
        <div className="error-message__text">
          <p className="error-message__title">
            {type === 'error' && 'Error'}
            {type === 'warning' && 'Advertencia'}
            {type === 'info' && 'Información'}
          </p>
          <p className="error-message__description">{message}</p>
        </div>
      </div>
      {onRetry && (
        <button
          className="error-message__retry-btn"
          onClick={onRetry}
          aria-label="Reintentar"
        >
          Reintentar
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
